import { OEButton, OEText } from '@openeducation/oe-it-components';
import { usePortalNavigationContext } from '@openeducation/oe-it-providers';
import { styled } from '@openeducation/oe-it-themes';
import React from 'react';

import { PortalPaths } from '../../interfaces/portal-paths.enum';

export interface NotFoundPageProps {}

export const NotFoundPage = () => {
  const { navigate } = usePortalNavigationContext();

  return (
    <Container>
      <OEText fontType="bold" fontSize={140}>
        404
      </OEText>
      <OEText fontType="bold" fontSize={22}>
        Page not found
      </OEText>
      <OEText fontSize={20}>
        The page you are looking for does not exist.
      </OEText>
      <OEButton onPress={() => navigate(PortalPaths.Home)}>Go to Home</OEButton>
    </Container>
  );
};

const Container = styled.View`
  background-color: ${({ theme }) => theme.color.lightPrimary};
  min-height: 90vh;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;
